module.exports = __webpack_public_path__ + "img/crystal_maiden.4b5728d9.png";